import { useSelector } from 'react-redux';

export const USER_TYPES = {
  user: 'User',
  celebrity: 'Celebrity',
  organization: 'Organization',
  admin: 'Admin'
};

export const getDashboardPath = userType => {
  switch (userType) {
    case USER_TYPES.celebrity:
      return '/creator/dashboard';
    case USER_TYPES.organization:
      return '/org/dashboard';
    case USER_TYPES.admin:
      return '/admin/dashboard';
    default:
      return '/';
  }
};

export default () =>
  useSelector(({ session: { authenticated, user, info, userToConfirm, token } }) => ({
    authenticated,
    info,
    userToConfirm,
    token,
    user: user || {},
    creatorLogged: authenticated && user?.type === USER_TYPES.celebrity,
    userLogged: authenticated && user?.type === USER_TYPES.user,
    orgLogged: authenticated && user?.type === USER_TYPES.organization,
    adminLogged: authenticated && user?.type === USER_TYPES.admin
  }));
